import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { User } from '../model/user.model';
import { SystemSettings } from '../state/system-settings.state';

/**
 * This is going to be a replacement for the angularJS version
 */
@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class AccountService {

    constructor(private httpClient: HttpClient) {
    }

    hasUserPermissionKey(user: User, permissionKey: string): boolean {
        if (user !== undefined && user.userPermissionKeys !== undefined) {
            for (const userPermissionKey of user.userPermissionKeys) {
                if (userPermissionKey === permissionKey) {
                    return true;
                }
            }
        }

        return false;
    }

    public hasUserPermission(route: Route, user: User): boolean {
        const data = route.data;
        if (!user || !data) {
            return false;
        }

        let access = false;

        if (data.permissions !== undefined && data.permissions.length > 0) {
            for (const permission of data.permissions) {
                if (permission.key !== undefined && this.hasUserPermissionKey(user, permission.key)) {
                    access = true;
                }
                if (permission.username !== undefined && permission.username === user.userName) {
                   access = true;
                }
                if (permission.deniedIfHasKey !== undefined && this.hasUserPermissionKey(user, permission.deniedIfHasKey)) {
                  access = false; // denied access to route when have, by example 'resource:pet'
                }
            }
            // false if here
        } else {
            access = true;
        }

        return access;
    }

    getSystemSettings(httpHeaders?: HttpHeaders): Observable<SystemSettings> {
        return this.httpClient
            .get<{settings: SystemSettings}>('servlets/accounts/systemsettings/', {observe: 'body'})
            .pipe(
                map((response: any) => response.settings)
            );
    }

}
